import type { IconSvgObject } from './types';

const LaptopCheckIcon: IconSvgObject = [
  ["path", { d: "M22.4999 20.5H1.49988L3.49988 16.5H20.4999L22.4999 20.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.4999 16.5V5C20.4999 4.17157 19.8283 3.5 18.9999 3.5H4.99988C4.17145 3.5 3.49988 4.17157 3.49988 5V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.49995 10.3996L10.9999 11.9996L15.4999 7.99963", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LaptopCheckIcon;
